<template>
  <div class="dropdown">
    <div
      class="dropdown header"
      @click="toggleDropdown($event)"
    >
      {{ header }}
    </div>
    <div
      v-if="isActive"
      class="dropdown content"
    >
      <div
        v-for="speed in options"
        :key="speed"
        class="ui compact button"
        @click="setSpeed(speed)"
      >
        {{ speed }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['header', 'options', 'setSpeed'],
  data: function () {
    return {
      isActive: false,
    }
  },
  methods: {
    toggleDropdown (event) {
      event.currentTarget.classList.toggle('is-active')
      this.isActive = !this.isActive
    },
  },
}
</script>

<style scoped>
  .dropdown {
    display: flex;
    flex-direction: row;
    /* height: 100%; */
    /* width: 100%; */
  }
  .dropdown .header {
    cursor: pointer;
    text-overflow: ellipsis;
    flex: initial;
  }
  .dropdown .header.is-active + .dropdown.content {
    height: auto;
    opacity: 1;
    visibility: visible;
    padding: 0rem 0rem 0rem .75rem;
  }
  .dropdown .content {
    flex: auto;
    height: 0;
    opacity: 0;
    overflow: hidden;
    transition: opacity .3s;
    visibility: hidden;
  }
  .ui.compact.button {
    padding: 0rem .5rem 0rem .5rem;
  }
</style>
